export default __webpack_public_path__ + "static/media/bkg--home-2.1520e294.jpg";